import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, clearToken } from '../../utils/authFetch';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let _cachedUser = null;

export const setCachedUser = (user) => {
  _cachedUser = user;
};

export const clearCachedUser = () => {
  _cachedUser = null;
};

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    _cachedUser ? true : null
  );
  const [user, setUser] = useState(_cachedUser);

  useEffect(() => {
    if (_cachedUser) {
      setIsAuthenticated(true);
      setUser(_cachedUser);
      return;
    }

    const token = getToken();
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/auth/me`);

        if (!response.ok) {
          throw new Error('Not authenticated');
        }

        const userData = await response.json();
        _cachedUser = userData;
        setIsAuthenticated(true);
        setUser(userData);
      } catch (error) {
        _cachedUser = null;
        clearToken();
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="glass rounded-xl p-6">
          <div className="animate-pulse text-foreground">Verifying session...</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (typeof children === 'function') {
    return children(user);
  }
  return React.cloneElement(children, { user });
};

export default ProtectedRoute;
